<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  // 被选中的项
  activeKey: {
    type: Number,
    required: true
  },
  tabs: { type: Array, required: true }
})
const emit = defineEmits(['tabClick', 'update:activeKey'])
// 点击某一个 tab
function tabClick({ key = 2 }) {
  emit('update:activeKey', key)
  emit('tabClick')
}
</script>
<template>
  <div class="order-tabs">
    <div
      class="tab-item"
      @click="tabClick(tab)"
      v-for="tab in tabs"
      :key="tab.key"
      :class="{ active: activeKey === tab.key }"
    >
      <!-- :count="tab.zMsgCount" :overflow-count="99"-->
      <a-badge :dot="!!tab.zMsgCount" :offset="[6, 0]">
        {{ tab.count ? `${tab.label}(${tab.count})` : tab.label }}
      </a-badge>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.order-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: white;
  border-bottom: 1px solid #e8e8e8;
  ::v-deep(.ant-badge-dot) {
    min-width: 12px;
    width: 12px;
    height: 12px;
  }
  .tab-item {
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    text-align: center;
    border: 1px solid #d9d9d9;
    width: 50%;
    height: 32px;
    line-height: 32px;
    &.active {
      border: 1px solid #1890ff;
      ::v-deep(.ant-badge) {
        color: #1890ff;
      }
    }
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>
